import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PaymentsModalType } from "entities/shared/subscriptionModel";
import { SubscriptionDataModel } from "entities/shared/subscriptionModel";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type SubscriptionState = {
  activePaymentModal: PaymentsModalType | null;
  subscription: SubscriptionDataModel | null;
};

const initialSubscriptionState: SubscriptionState = {
  activePaymentModal: null,
  subscription: null,
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState: initialSubscriptionState,
  reducers: {
    setActivePaymentModal: (state, action: PayloadAction<PaymentsModalType | null>) => {
      state.activePaymentModal = action.payload;
    },
    setSubscription: (state, action: PayloadAction<SubscriptionDataModel | null>) => {
      state.subscription = action.payload;
    },
  },
});

const subscriptionBaseSelector = createBaseSelector(subscriptionSlice);

registerSlice([subscriptionSlice]);

export const subscriptionStore = {
  actions: subscriptionSlice.actions,
  selectors: {
    activePaymentModal: createSelector(subscriptionBaseSelector, (s) => s.activePaymentModal),
    subscription: createSelector(subscriptionBaseSelector, (s) => s.subscription),
  },
};
